import { render, staticRenderFns } from "./DetailsJobOffer.vue?vue&type=template&id=435b144b&scoped=true&"
import script from "./DetailsJobOffer.vue?vue&type=script&lang=ts&"
export * from "./DetailsJobOffer.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsJobOffer.vue?vue&type=style&index=0&id=435b144b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b144b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VRow})
